import React from 'react';
import { useTitle } from 'react-use';
import Head from '@/components/Head';
import he from 'he';

const titleSuffix = 'Give InKind';
const titleSeparator = ' - ';

export function useGIKTitle(title: string, options?: Parameters<typeof useTitle>[1]) {
  const _title = he.decode(title ? `${title}${titleSeparator}${titleSuffix}` : titleSuffix);
  useTitle(_title, options);

  return (
    <Head>
      <title>{_title}</title>
    </Head>
  );
}
